const { assoc, pipe } = require("ramda");

/**
 * Helper module to send a 404 - Not Found HTTP response.
 */
module.exports = (ctx) => pipe(assoc("status", 404), ctx.error)({});
